import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { WeekdaySearches } from '@/features/admin/weekday-searches'

const searchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(20),
  filter: z.string().optional().catch(''),
})

export const Route = createFileRoute(
  '/_authenticated/admin/weekday-searches/'
)({
  validateSearch: searchSchema,
  component: () => <WeekdaySearches />,
})
